import React from "react";
import FormGroupPlainText from "../formGroupPlainText";
import {
    APPLICATION_FORM_FIELDS,
    CANADA_COUNTRY,
    COUNTRY,
    DEFAULT_MEDICAL_EXPERT_FEE,
    INFO_TEXT_EDIT_WITH_APPROVAL,
    INFO_TEXT_EDIT_WITHOUT_APPROVAL,
} from "../../helpers/variables";
import {
    checkIfQuestionHasPendingChanges,
    checkIfQuestionsHasBeenModified,
    getTriggeredQuestion
} from "../../helpers/questions/functions";
import EditIcon from "../icons/editIcon";
import {checkIfQuestionAnswerUpdateRequiresARAGApproval} from "../../helpers/approvalSettings/functions";
import moment from "moment";
import ApplicationQuestion from "./applicationQuestion";

const PlainApplicationForm = (props) => {
    const {
        checkIfQuestionIsEditable,
        mapEditingQuestionOrFieldToEditingSetting,
        openDeleteAnswerModal,
        openHistoryModal,
        onClickActionLink
    } = props;

    return (
        <form className="form-horizontal">
            <FormGroupPlainText
                onLabelClick={() => openHistoryModal(APPLICATION_FORM_FIELDS.SOLICITOR_REFERENCE.fakeQuestion)}
                labelAsALink={checkIfQuestionsHasBeenModified(
                    null,
                    props.Store.selectedApplication, APPLICATION_FORM_FIELDS.SOLICITOR_REFERENCE.fieldName
                )}
                LeftWrapper="col-sm-3"
                InputWrapper="manageSolicitorAccount-data col-sm-6"
                Label={APPLICATION_FORM_FIELDS.SOLICITOR_REFERENCE.name}
                Text={props.Store.selectedApplication.solicitorReference}
                RightWrapper={'col-sm-3'}
                rightData={
                    [
                        checkIfQuestionIsEditable(
                            null,
                            APPLICATION_FORM_FIELDS.SOLICITOR_REFERENCE.fieldName
                        ) && (
                            <EditIcon
                                key={1}
                                informationText={
                                    checkIfQuestionAnswerUpdateRequiresARAGApproval(
                                        mapEditingQuestionOrFieldToEditingSetting(
                                            {
                                                name: APPLICATION_FORM_FIELDS.SOLICITOR_REFERENCE.name,
                                                inputType: 'text',
                                                machineName: 'solicitorReference',
                                                isStandard: true
                                            }
                                        ),
                                        props.approvalOptions
                                    ) ? INFO_TEXT_EDIT_WITH_APPROVAL : INFO_TEXT_EDIT_WITHOUT_APPROVAL
                                }
                                className={
                                    checkIfQuestionAnswerUpdateRequiresARAGApproval(
                                        mapEditingQuestionOrFieldToEditingSetting(
                                            {
                                                name: APPLICATION_FORM_FIELDS.SOLICITOR_REFERENCE.name,
                                                inputType: 'text',
                                                machineName: 'solicitorReference',
                                                isStandard: true
                                            }
                                        ),
                                        props.approvalOptions
                                    ) ? "edit-icon--orange" : null
                                }
                                onClick={() => props.openEditQuestionAnswerModal({
                                    questionAnswerForEdit: {
                                        name: APPLICATION_FORM_FIELDS.SOLICITOR_REFERENCE.name,
                                        inputType: 'text',
                                        machineName: 'solicitorReference',
                                        isStandard: true
                                    },
                                    questionAnswer:props.Store.selectedApplication.solicitorReference
                                })}
                            />
                        ),
                        checkIfQuestionHasPendingChanges(null, props.Store.selectedApplication, APPLICATION_FORM_FIELDS.SOLICITOR_REFERENCE.fieldName) && (
                            <div className={"newApplication__awaiting-approval-wrapper pull-right"} key={2}>
                                Awaiting Approval
                            </div>
                        ),
                    ]
                }
            />
            {COUNTRY != CANADA_COUNTRY && 
            <FormGroupPlainText
                onLabelClick={() => openHistoryModal(APPLICATION_FORM_FIELDS.WORK_SOURCE.fakeQuestion)}
                labelAsALink={checkIfQuestionsHasBeenModified(
                    null,
                    props.Store.selectedApplication, APPLICATION_FORM_FIELDS.WORK_SOURCE.fieldName
                )}
                LeftWrapper="col-sm-3"
                InputWrapper="manageSolicitorAccount-data col-sm-6"
                Label={APPLICATION_FORM_FIELDS.WORK_SOURCE.name}
                Text={props.Store.workSourceName}
                RightWrapper={'col-sm-3'}
                rightData={
                    [
                        checkIfQuestionIsEditable(
                            null,
                            APPLICATION_FORM_FIELDS.WORK_SOURCE.fieldName
                        ) && (
                            <EditIcon
                                key={1}
                                informationText={
                                    checkIfQuestionAnswerUpdateRequiresARAGApproval(
                                        mapEditingQuestionOrFieldToEditingSetting(
                                            {
                                                name: APPLICATION_FORM_FIELDS.WORK_SOURCE.name,
                                                inputType: 'drop down',
                                                machineName: 'workSourceId',
                                                isStandard: true,
                                            }
                                        ),
                                        props.approvalOptions
                                    ) ? INFO_TEXT_EDIT_WITH_APPROVAL : INFO_TEXT_EDIT_WITHOUT_APPROVAL
                                }
                                className={
                                    checkIfQuestionAnswerUpdateRequiresARAGApproval(
                                        mapEditingQuestionOrFieldToEditingSetting(
                                            {
                                                name: APPLICATION_FORM_FIELDS.WORK_SOURCE.name,
                                                inputType: 'drop down',
                                                machineName: 'workSourceId',
                                                isStandard: true,
                                            }
                                        ),
                                        props.approvalOptions
                                    ) ? "edit-icon--orange" : null
                                }
                                onClick={() => props.openEditQuestionAnswerModal({
                                    questionAnswerForEdit: {
                                        name: APPLICATION_FORM_FIELDS.WORK_SOURCE.name,
                                        inputType: 'drop down',
                                        machineName: 'workSourceId',
                                        isStandard: true,
                                        options: props.workSourceOptions.map(i => ({id: i.key, name: i.value}))
                                    },
                                    questionAnswer:props.Store.selectedApplication.workSourceId
                                })}
                            />
                        ),
                        checkIfQuestionHasPendingChanges(null, props.Store.selectedApplication, APPLICATION_FORM_FIELDS.WORK_SOURCE.fieldName) && (
                            <div className={"newApplication__awaiting-approval-wrapper pull-right"} key={2}>
                                Awaiting Approval
                            </div>
                        ),
                    ]
                }
            />}
            <hr className="generalTab-hr"/>
            <FormGroupPlainText
                onLabelClick={() => openHistoryModal(APPLICATION_FORM_FIELDS.CLIENT_NAME.fakeQuestion)}
                labelAsALink={checkIfQuestionsHasBeenModified(
                    null,
                    props.Store.selectedApplication, APPLICATION_FORM_FIELDS.CLIENT_NAME.fieldName
                )}
                LeftWrapper="col-sm-3"
                InputWrapper="manageSolicitorAccount-data col-sm-6"
                Label={APPLICATION_FORM_FIELDS.CLIENT_NAME.name}
                Text={props.Store.selectedApplication.clientName}
                RightWrapper={'col-sm-3'}
                rightData={
                    checkIfQuestionIsEditable(
                        null,
                        APPLICATION_FORM_FIELDS.CLIENT_NAME.fieldName
                    ) && (
                        [
                            <EditIcon
                                key={1}
                                informationText={
                                    checkIfQuestionAnswerUpdateRequiresARAGApproval(
                                        mapEditingQuestionOrFieldToEditingSetting(
                                            {
                                                name: APPLICATION_FORM_FIELDS.CLIENT_NAME.name,
                                                inputType: 'text',
                                                machineName: 'clientName',
                                                isStandard: true
                                            }
                                        ),
                                        props.approvalOptions
                                    ) ? INFO_TEXT_EDIT_WITH_APPROVAL : INFO_TEXT_EDIT_WITHOUT_APPROVAL
                                }
                                className={
                                    checkIfQuestionAnswerUpdateRequiresARAGApproval(
                                        mapEditingQuestionOrFieldToEditingSetting(
                                            {
                                                name: APPLICATION_FORM_FIELDS.CLIENT_NAME.name,
                                                inputType: 'text',
                                                machineName: 'clientName',
                                                isStandard: true
                                            }
                                        ),
                                        props.approvalOptions
                                    ) ? "edit-icon--orange" : null
                                }
                                onClick={() => props.openEditQuestionAnswerModal({
                                    questionAnswerForEdit: {
                                        name: APPLICATION_FORM_FIELDS.CLIENT_NAME.name,
                                        inputType: 'text',
                                        machineName: 'clientName',
                                        isStandard: true
                                    },
                                    questionAnswer:props.Store.selectedApplication.clientName
                                })}
                            />,
                            checkIfQuestionHasPendingChanges(null, props.Store.selectedApplication, APPLICATION_FORM_FIELDS.CLIENT_NAME.fieldName) && (
                                <div className={"newApplication__awaiting-approval-wrapper pull-right"} key={2}>
                                    Awaiting Approval
                                </div>
                            ),
                        ]
                    )
                }
            />
            <FormGroupPlainText
                onLabelClick={() => openHistoryModal(APPLICATION_FORM_FIELDS.DATE_OF_BIRTH.fakeQuestion)}
                labelAsALink={checkIfQuestionsHasBeenModified(
                    null,
                    props.Store.selectedApplication, APPLICATION_FORM_FIELDS.DATE_OF_BIRTH.fieldName
                )}
                LeftWrapper="col-sm-3"
                InputWrapper="manageSolicitorAccount-data col-sm-6"
                Label={APPLICATION_FORM_FIELDS.DATE_OF_BIRTH.name}
                Text={props.Store.selectedApplication.dateOfBirth !== null?moment(props.Store.selectedApplication.dateOfBirth).format("DD/MM/YYYY"): ''}
                RightWrapper={'col-sm-3'}
                rightData={
                    checkIfQuestionIsEditable(
                        null,
                        APPLICATION_FORM_FIELDS.DATE_OF_BIRTH.fieldName
                    ) && (
                        [
                            <EditIcon
                                key={1}
                                informationText={
                                    checkIfQuestionAnswerUpdateRequiresARAGApproval(
                                        mapEditingQuestionOrFieldToEditingSetting(
                                            {
                                                name: APPLICATION_FORM_FIELDS.DATE_OF_BIRTH.name,
                                                inputType: 'calendar',
                                                machineName: 'dateOfBirth',
                                                id: 'dateOfBirth',
                                                isStandard: true
                                            }
                                        ),
                                        props.approvalOptions
                                    ) ? INFO_TEXT_EDIT_WITH_APPROVAL : INFO_TEXT_EDIT_WITHOUT_APPROVAL
                                }
                                className={
                                    checkIfQuestionAnswerUpdateRequiresARAGApproval(
                                        mapEditingQuestionOrFieldToEditingSetting(
                                            {
                                                name: APPLICATION_FORM_FIELDS.DATE_OF_BIRTH.name,
                                                inputType: 'calendar',
                                                machineName: 'dateOfBirth',
                                                id: 'dateOfBirth',
                                                isStandard: true
                                            }
                                        ),
                                        props.approvalOptions
                                    ) ? "edit-icon--orange" : null
                                }
                                onClick={() => props.openEditQuestionAnswerModal({
                                    questionAnswerForEdit: {
                                        name: APPLICATION_FORM_FIELDS.DATE_OF_BIRTH.name,
                                        inputType: 'calendar',
                                        machineName: 'dateOfBirth',
                                        id: 'dateOfBirth',
                                        isStandard: true
                                    },
                                    questionAnswer:props.Store.selectedApplication.dateOfBirth !== null?moment(props.Store.selectedApplication.dateOfBirth).format("DD/MM/YYYY"): ''
                                })}
                            />,
                            checkIfQuestionHasPendingChanges(null, props.Store.selectedApplication, APPLICATION_FORM_FIELDS.DATE_OF_BIRTH.fieldName) && (
                                <div className={"newApplication__awaiting-approval-wrapper pull-right"} key={2}>
                                    Awaiting Approval
                                </div>
                            ),
                        ]
                    )
                }
            />
            <FormGroupPlainText
                onLabelClick={() => openHistoryModal(APPLICATION_FORM_FIELDS.ADDRESS.fakeQuestion)}
                labelAsALink={checkIfQuestionsHasBeenModified(
                    null,
                    props.Store.selectedApplication, APPLICATION_FORM_FIELDS.ADDRESS.fieldName
                )}
                LeftWrapper="col-sm-3"
                InputWrapper="manageSolicitorAccount-data col-sm-6"
                Label={APPLICATION_FORM_FIELDS.ADDRESS.name}
                Text={props.Store.selectedApplication.address}
                RightWrapper={'col-sm-3'}
                rightData={
                    checkIfQuestionIsEditable(
                        null,
                        APPLICATION_FORM_FIELDS.ADDRESS.fieldName
                    ) && (
                        [
                            <EditIcon
                                key={1}
                                informationText={
                                    checkIfQuestionAnswerUpdateRequiresARAGApproval(
                                        mapEditingQuestionOrFieldToEditingSetting(
                                            {
                                                name: APPLICATION_FORM_FIELDS.ADDRESS.name,
                                                inputType: 'text',
                                                machineName: 'address',
                                                isStandard: true
                                            }
                                        ),
                                        props.approvalOptions
                                    )  ? INFO_TEXT_EDIT_WITH_APPROVAL : INFO_TEXT_EDIT_WITHOUT_APPROVAL
                                }
                                className={
                                    checkIfQuestionAnswerUpdateRequiresARAGApproval(
                                        mapEditingQuestionOrFieldToEditingSetting(
                                            {
                                                name: APPLICATION_FORM_FIELDS.ADDRESS.name,
                                                inputType: 'text',
                                                machineName: 'address',
                                                isStandard: true
                                            }
                                        ),
                                        props.approvalOptions
                                    ) ? "edit-icon--orange" : null
                                }
                                onClick={() => props.openEditQuestionAnswerModal({
                                    questionAnswerForEdit: {
                                        name: APPLICATION_FORM_FIELDS.ADDRESS.name,
                                        inputType: 'text',
                                        machineName: 'address',
                                        isStandard: true
                                    },
                                    questionAnswer:props.Store.selectedApplication.address
                                })}
                            />,
                            checkIfQuestionHasPendingChanges(null, props.Store.selectedApplication, APPLICATION_FORM_FIELDS.ADDRESS.fieldName) && (
                                <div className={"newApplication__awaiting-approval-wrapper pull-right"} key={2}>
                                    Awaiting Approval
                                </div>
                            ),
                        ]
                    )
                }
            />
            <FormGroupPlainText
                onLabelClick={() => openHistoryModal(APPLICATION_FORM_FIELDS.POST_CODE.fakeQuestion)}
                labelAsALink={checkIfQuestionsHasBeenModified(
                    null,
                    props.Store.selectedApplication, APPLICATION_FORM_FIELDS.POST_CODE.fieldName
                )}
                LeftWrapper="col-sm-3"
                InputWrapper="manageSolicitorAccount-data col-sm-6"
                Label={APPLICATION_FORM_FIELDS.POST_CODE.name}
                Text={props.Store.selectedApplication.postCode}
                RightWrapper={'col-sm-3'}
                rightData={
                    checkIfQuestionIsEditable(
                        null,
                        APPLICATION_FORM_FIELDS.POST_CODE.fieldName
                    ) && (
                        [
                            <EditIcon
                                key={1}
                                informationText={
                                    checkIfQuestionAnswerUpdateRequiresARAGApproval(
                                        mapEditingQuestionOrFieldToEditingSetting(
                                            {
                                                name: APPLICATION_FORM_FIELDS.POST_CODE.name,
                                                inputType: 'text',
                                                machineName: 'postCode',
                                                isStandard: true
                                            }
                                        ),
                                        props.approvalOptions
                                    )  ? INFO_TEXT_EDIT_WITH_APPROVAL : INFO_TEXT_EDIT_WITHOUT_APPROVAL
                                }
                                className={
                                    checkIfQuestionAnswerUpdateRequiresARAGApproval(
                                        mapEditingQuestionOrFieldToEditingSetting(
                                            {
                                                name: APPLICATION_FORM_FIELDS.POST_CODE.name,
                                                inputType: 'text',
                                                machineName: 'postCode',
                                                isStandard: true
                                            }
                                        ),
                                        props.approvalOptions
                                    ) ? "edit-icon--orange" : null
                                }
                                onClick={() => props.openEditQuestionAnswerModal({
                                    questionAnswerForEdit: {
                                        name: APPLICATION_FORM_FIELDS.POST_CODE.name,
                                        inputType: 'text',
                                        machineName: 'postCode',
                                        isStandard: true
                                    },
                                    questionAnswer:props.Store.selectedApplication.postCode
                                })}
                            />,
                            checkIfQuestionHasPendingChanges(null, props.Store.selectedApplication, APPLICATION_FORM_FIELDS.POST_CODE.fieldName) && (
                                <div className={"newApplication__awaiting-approval-wrapper pull-right"} key={2}>
                                    Awaiting Approval
                                </div>
                            ),
                        ]
                    )
                }
            />
            {
                Object.keys(props.groupedQuestions).map( (key, index) => {
                    return <div key={index}>
                        <hr className="generalTab-hr"/>
                        {
                            props.groupedQuestions[key].map(question => {
                                if(question.questionDisplaySettings !== null &&
                                    !getTriggeredQuestion(props.Store.formData, props.Store.questions,props.Store?.questions?.find(q=> q.id === question.id)) ) {
                                return null
                                }
                                return (
                                    <ApplicationQuestion
                                        openDeleteAnswerModal={openDeleteAnswerModal}
                                        onAttachmentRequest={(attachment) => {
                                            props.requestApplicationAttachment({
                                                applicationId: props.Store.selectedApplication.id,attachmentId:attachment.id,
                                                relativeUrl: attachment.relativeUrl
                                            });
                                        }}
                                        attachments={props.Store.attachmentsForDisplay}
                                        approvalOptions={props.approvalOptions}
                                        checkIfQuestionIsEditable={checkIfQuestionIsEditable}
                                        mapEditingQuestionOrFieldToEditingSetting={mapEditingQuestionOrFieldToEditingSetting}
                                        openEditQuestionAnswerModal={props.openEditQuestionAnswerModal}
                                        application={props.Store.selectedApplication}
                                        openHistoryModal={openHistoryModal}
                                        opponentQuestions={props.Store.opponentQuestions}
                                        onOpponentAdd={() => props.ChangeNewAppField('extraOpponents', [...props.Store.extraOpponents, {
                                            name: '',
                                            prospectsOptionId: '',
                                            insuredOptionId: '',
                                            satisfiedOptionId: '',
                                            insurerOptionId: '',
                                            otherInsurerName: ''
                                        }])}
                                        removeExtraOpponent={props.RemoveExtraOpponent}
                                        extraOpponents={props.Store.extraOpponents}
                                        updateExtraOpponents={props.UpdateExtraOpponents}
                                        removeMedicalExpertFeesTableRow={props.removeMedicalExpertFeesTableRow}
                                        onMedicalFeeAdd={() => props.ChangeNewAppField('medExpertFees', [...props.Store.medExpertFees, DEFAULT_MEDICAL_EXPERT_FEE])}
                                        isPlain={true}
                                        medExpertFees={props.Store.medExpertFees}
                                        updateMedicalExpertFees={props.updateMedicalExpertFees}
                                        breachCausationCp={props.breachCausationCp}
                                        filedDisabled={((Object.keys(props.Store.selectedApplication).length !== 0 && props.Store.selectedApplication.constructor === Object) && props.Store.selectedApplication.policyStatus !== 'Draft') }
                                        onDrop={props.OnDrop}
                                        handleDateChange={props.HandleDateChange}
                                        questions={props.Store.questions}
                                        key={question.id}
                                        textAreaRows={8}
                                        question={question}
                                        formData={props.Store.formData}
                                        handleSelectChange={props.HandleSelectChange}
                                        handleTextInputChange={props.HandleFormCompChange}
                                        onClickActionLink={props.onClickActionLink}
                                    />
                                );
                            })
                        }
                    </div>
                })
            }
        </form>
    )
};

export default PlainApplicationForm;